import { IconList } from "@/components/IconList";
import React, { useMemo } from "react";
import { buildContactItems } from "../utils";
import { VcardContentProps } from "../types";

export const VcardContent = ({
  data,
  translations,
  addressData,
  isInitialPreview,
}: VcardContentProps) => {
  const contactItems = useMemo(() => {
    return buildContactItems({
      data,
      translations,
      addressData,
      isInitialPreview: isInitialPreview ?? false,
    });
  }, [data, translations, addressData, isInitialPreview]);

  return (
    <div className="vcard-template__content">
      <div>
        {contactItems.map((item) => (
          <IconList
            key={item.id}
            iconItem
            items={item}
            uncheckValidURL={item.isUncheckValidURL}
          />
        ))}
      </div>
    </div>
  );
};
